import * as React from "react";

interface ThinTimesIconProps {
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties
}

export class ThinTimesIcon extends React.Component<ThinTimesIconProps> {
  render() {
    return (
      <div {...this.props} data-testid="thin-times-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="current" xmlns="http://www.w3.org/2000/svg">
          <g id="X">
            <path id="Vector (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z" fill="#F8983A" />
            <path id="Vector (Stroke)_2" fillRule="evenodd" clipRule="evenodd" d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z" fill="#F8983A" />
          </g>
        </svg>
      </div>
    );
  }
}
